// extracted by mini-css-extract-plugin
module.exports = {"priceOption":"style_priceOption__6EoAX","priceTitle":"style_priceTitle__2ipLC","highlight":"style_highlight__3WG93"};